/**
 * Parses grouped tag API responses: [{ source: "MY"|"PUBLIC", tags: [...] }, ...]
 */
export function parseTagsBySource(data) {
  const my = [];
  const publicTags = [];

  if (!Array.isArray(data)) {
    return { my, public: publicTags };
  }

  data.forEach((group) => {
    if (!group || typeof group !== "object") {
      return;
    }
    const list = Array.isArray(group.tags)
      ? group.tags.filter((tag) => tag && String(tag).trim())
      : [];
    if (group.source === "MY") {
      my.push(...list);
    } else if (group.source === "PUBLIC") {
      publicTags.push(...list);
    }
  });

  return {
    my: [...new Set(my)],
    public: [...new Set(publicTags)],
  };
}
